export default "\n\n<!-- <app-home></app-home> -->\n\n<!-- <app-info></app-info> -->\n\n<router-outlet></router-outlet>"